import React from 'react'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'
import settings from '@nobia/zeus-components/lib/settings'
import { useTranslation } from '../../../utils/useTranslation'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 40px ${prop('theme.body.padding')};
  align-items: baseline;
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    align-items: flex-start;
    flex-direction: row;
  }
`
const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    justify-content: center;
  }
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    width: 50%;
    justify-content: flex-end;
  }
  @media (min-width: 1200px) {
    padding: 0 0 0 46px;
  }
`
const IMG = styled.img`
  border-radius: 4px;
  width: 100%;
  object-fit: contain;
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    max-width: ${prop('theme.badaPromo.image.maxWidth')};
  }
`
const ListWrapper = styled.div`
  position: relative;
  width: 100%;
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    max-width: 370px;
    margin: 0 0 0 60px;
  }
  @media (min-width: 1200px) {
    margin: 0 0 0 80px;
  }
`
const H2 = styled.h2`
  margin: 20px 0;
  text-align: left;
  font-size: ${theme('badaPromo.title.fontSize')};
  line-height: ${theme('badaPromo.title.lineHeight')};
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    margin: 20px 0 40px 0;
  }
  @media (min-width: 1200px) {
    margin: 24px 0 40px 0;
  }
`
const P = styled.p`
  font-size: 16px;
  text-align: left;
  margin: 0 0 0px 55px;
  max-width: 350px;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    max-width: 90%;
  }
`
const UL = styled.ul`
  position: relative;
  margin: 30px 0 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    left: auto;
    right: auto;
  }
`
const LI = styled.li`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 24px;
`
const A = styled.a`
  text-decoration: none;
  background-color: ${p => p.theme.colors.button};
  border-radius: ${p => p.theme.button.borderRadius || '3px'};
  color: ${theme('colors.white')};
  padding: ${theme('button.padding') || '15px'};
  margin: 20px 0 0 0;
  min-width: 170px;
  width: 100%;
  font-size: 16px;
  font-weight: ${prop('theme.button.fontWeight')};
  cursor: pointer;
  transition: opacity 0.5s;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    max-width: max-content;
  }
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    width: auto;
  }
  &:hover {
    opacity: 0.8;
    color: ${theme('colors.white')};
  }
`

const Icon = styled.div`
  justify-content: baseline;
  position: absolute;
  width: 30px;
  height: 30px;
  left: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: ${({ backgroundUrl }) => `url(${backgroundUrl})`};
`

const promoBullets = [
  {
    icon:
      'https://www.magnet.co.uk/media-assets/image/upload/v1629380282/Magnet/Icons/store.svg',
    text: 'instore-and-online.description',
  },
  {
    icon:
      'https://www.magnet.co.uk/media-assets/image/upload/v1629380282/Magnet/Icons/monitor.svg',
    text: 'expert-guidance.description',
  },
  {
    icon:
      'https://www.magnet.co.uk/media-assets/image/upload/v1629380282/Magnet/Icons/box.svg',
    text: '3D-design.description',
  },
  {
    icon:
      'https://www.magnet.co.uk/media-assets/image/upload/v1629380282/Magnet/Icons/quote-document.svg',
    text: 'kitchen-project-account.description',
  },
]

const BadaPromo = () => {
  const { t } = useTranslation('app.bada')

  return (
    <Wrapper>
      <ImageWrapper>
        <IMG src={t('img.src')} alt="" width={460} height={307} />
      </ImageWrapper>
      <ListWrapper>
        <H2>{t('title')}</H2>
        <UL>
          {settings.brand !== 'marbodal'
            ? promoBullets.map(promoBullet => {
                const text = t(promoBullet.text)
                return !text.startsWith('app.') ? (
                  <LI>
                    <Icon backgroundUrl={promoBullet.icon} />
                    <P>{text}</P>
                  </LI>
                ) : null
              })
            : promoBullets
                .filter((x, i) => i !== 2)
                .map(promoBullet => {
                  const text = t(promoBullet.text)
                  return !text.startsWith('app.') ? (
                    <LI>
                      <Icon backgroundUrl={promoBullet.icon} />
                      <P>{text}</P>
                    </LI>
                  ) : null
                })}
          <A
            href={t('call-to-action.link')}
            rel="noopener noreferer"
            target="_blank"
          >
            {t('call-to-action.description')}
          </A>
        </UL>
      </ListWrapper>
    </Wrapper>
  )
}

export default BadaPromo
